import { UseLoadingReturn } from "@/hooks/use-loading";
import campaignScheduleService from "@/services/campaign-schedule.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type UseRemoveCampaignScheduleReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveCampaignSchedule = (): UseRemoveCampaignScheduleReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (scheduleId) => campaignScheduleService.delete(scheduleId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveCampaignSchedule;
